import { Videos } from '../_app/cuchillo/components/Videos';
import { Acordions } from '../_app/cuchillo/components/Acordions';
import Forms from '../_app/cuchillo/forms/FormValidator';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Page from '../_app/cuchillo/pages/Page';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import Scene from '../3D/Scene';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Basics } from '../_app/cuchillo/core/Basics';
import Cmp from '../windows/Cmp';

export default class Default extends Page {
  constructor(__hasScroll = true) {
    super();

    this.hasScroll = __hasScroll;

    Videos.init();
    Acordions.init();
    Forms.init();

    [...GetBy.selector('[data-toggle-cmp]')].map(item => {
      item.addEventListener(Basics.clickEvent, Cmp._calls.click);
    });

    if(this.container.classList.contains('--menu-transparent')) {
      document.body.classList.add('--menu-transparent');
    } else {
      document.body.classList.remove('--menu-transparent');
    }
  }

  //SHOW
  beforeShow() {
    super.beforeShow();

    this._sceneBeforeShow(); // gestió del render 3D ABANS de Scroll.init (els scroll-items el troben preparat)

    // Home fuerza 0; el resto: history (back) o sessionStorage (refresh)
    Scroll.init({ startY: this.getStartScrollY() }, !this.hasScroll);
    Keyboard.mountPage(this.id);
  }

  /** Scroll inicial. Override en Home → siempre 0. */
  getStartScrollY() {
    if (window.location.hash) return 0; // el ancla se resuelve en afterShow
    const fromHistory = history.state?.scrollY;
    if (typeof fromHistory === 'number' && fromHistory > 0) return fromHistory;
    // Solo en carga/refresh: si no, un link SPA a la misma URL empezaría a mitad de página
    if (this.isFirstTime) return Scroll.readPersistedY();
    return 0;
  }

  // Pàgina SENSE escena 3D: si NO és el 1r cop (venim d'una altra pàgina), AMAGA el render (fade opacitat
  // del canvas a 0). No podem fer hide en SORTIR de home/about (no sabem on anem) → ho fem en ARRIBAR aquí.
  // Home/About SOBREESCRIUEN aquest mètode per iniciar/mostrar l'escena (l'escena només s'inicia allà).
  _sceneBeforeShow() {
    Scene.seabedEnabled = false; // el fons marí del footer només existeix a Home/About
    if (!this.isFirstTime) Scene.hide();
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.show(() => {
        Preloader.hide(() => { this.afterShow() });
      });
    } else {
      Wrap.show(() => { this.afterShow() });
    }
  }

  afterShow() {
    super.afterShow();
    Scroll.show();
    // Si hay ancla en la URL, ir ahí (tiene prioridad sobre restore)
    Scroll.gotoHash({ immediate: this.isFirstTime });
  }

  //HIDE
  beforeHide() {
    Keyboard.unmountPage(this.id);
    super.beforeHide();
  }

  hide__effect() {
    Scroll.hide();
    Wrap.hide(() => { this.afterHide(); });
  }

  afterHide() {
    Scroll.dispose();
    super.afterHide();

    [...GetBy.selector('[data-toggle-cmp]')].map(item => {
      item.removeEventListener(Basics.clickEvent, Cmp._calls.click);
    });
  }

  //RESIZE
  resize() {
    super.resize();
    Acordions.resize();
  }

  //LOOP
  loop() {
    if (this._isActive) {
      super.loop();
    }
  }
}

ControllerPage._addPage('default', Default);
